// šī ir komponentu bibliotēka vecajam frontendam

import { defineCustomElement } from 'vue'
import FieldAudio from '@/components/fields/FieldAudioPlay.vue'
import FieldAudioAdmin from '@/components/fields/FieldAudioAdmin.vue'
import HelpBlock from '@/components/common/HelpBlock.vue'
import '@/assets/boxicons/boxicons.css'
import '@/assets/scss/components.scss'

console.log(FieldAudio.styles) // ["/* inlined css */"]

// convert into custom element constructor
const FieldAudioElement = defineCustomElement(FieldAudio, { shadowRoot: false })
const FieldAudioAdminElement = defineCustomElement(FieldAudioAdmin, { shadowRoot: false })
const HelpBlockElement = defineCustomElement(HelpBlock, { shadowRoot: false })

// register
customElements.define('liv-audio', FieldAudioElement)
customElements.define('liv-audio-admin', FieldAudioAdminElement)
customElements.define('liv-help', HelpBlockElement)
